import type { AppStateRepository } from './AppStateRepository'
import { LocalKeyValueRepository, type KeyValueRepository } from '@/repositories/key-value'
import { storageHealth } from '@/services/storage-health'

export const APP_STATE_STORAGE_KEY = 'openelp-store-v3'
export const APP_STATE_VERSION = 19

export class LocalAppStateRepository implements AppStateRepository {
  constructor(private readonly storage: KeyValueRepository = new LocalKeyValueRepository()) {}

  getItem(name: string): string | null {
    return this.storage.get(name)
  }

  setItem(name: string, value: string): void {
    const saved = this.storage.set(name, value)
    if (!saved) {
      const message = '无法保存 OpenELP 本地学习数据。请立即导出备份，并检查浏览器存储空间或隐私设置。'
      storageHealth.reportFailure(message)
      throw new Error(message)
    }
    storageHealth.clear()
  }

  removeItem(name: string): void {
    this.storage.remove(name)
  }
}

export const localAppStateRepository = new LocalAppStateRepository()
